import React from "react";
import Select from "react-select";
import { themedSelectStyles } from "./selectTheme.js";

export const BasicSelect = ({
  placeholder,
  name,
  onChange,
  value,
  options = [],
  error,
  height = "30px",
  width = "100%",
  label,
  required,
  isSearchable = false,
  ...props
}) => {
  const styles = themedSelectStyles({
    control: (styles) => ({
      ...styles,
      border: `1px solid ${error ? "var(--danger)" : "var(--stroke-alt)"}`,
      height: `${props.isMulti ? "" : height}`,
      minHeight: `${props.isMulti ? height : "38px"}`,
      width: width,
      borderRadius: "8px",
      ":focus": {
        borderColor: error ? "var(--danger)" : "var(--primary)",
      },
      ":hover": {
        borderColor: error ? "var(--danger)" : "var(--primary)",
      },
      whiteSpace: "nowrap",
    }),
  });

  return (
    <>
      {label && (
        <label>
          {label}
          {required && <span>*</span>}
        </label>
      )}
      <div className="form__select">
        <Select
          options={options}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          name={name}
          styles={styles}
          isSearchable={isSearchable}
          {...props}
        />
      </div>
    </>
  );
};
